goog.provide('el8.appchart.refpanel.history');

goog.require('el8.appchart.dialog.smokingStatus');

goog.require('el8.appchart.metrics');
goog.require('el8.appchart.permissions');
goog.require('el8.practicedata.immunizationRegistries');
goog.require('el8.ptdata.base');
goog.require('el8.ptdata.historyItems');
goog.require('el8.util.amplitude.helpers');
goog.require('el8.util.event');
goog.require('el8.uiwidget.alert');
goog.require('el8.appchart.refpanel.RefPanelSection');
goog.require('el8.uiwidget.listeditor');
goog.require('el8.template.appchart.refpanel.history');
goog.require('el8.service.urls');

el8.appchart.refpanel.history = (function() {

    var idPrefix = 'rp_historyitem';
    var containerSelector = '#pfsh-summary, #patient-info-summary, #cognitive-functional-status-summary, #maint-history-summary';
    var listeditors = {};

    var _HISTORY_ITEM_TYPES = el8Globals.FEATURES.ProvidersNetwork ?
        _.reject(el8.util.consts.HISTORY_ITEM_TYPES, function(t) { return t === 'consultation'; }) :
        el8.util.consts.HISTORY_ITEM_TYPES;

    var reportOnFirstLoad = el8.appchart.metrics.getChartLoadCallback('history');

    // Tracks the edit source for each history item: 'inline' vs 'actions menu'
    var editSourceForId = {};

    var that = new el8.appchart.refpanel.RefPanelSection({

        container: $(containerSelector),
        loadFn: function(callbackFn) {
            var historyRequest = el8.ptdata.historyItems.loadAll({
                success: function() {
                    $(containerSelector).find('label').show(); // these labels overlap until the LE is rendered
                    _HISTORY_ITEM_TYPES.map(function(type) {
                        listeditors[type].showLe(); // once there are contents, show the LE
                    });
                }
            });
            var smokingRequest = $.el8_ajax({
                type: 'GET',
                url: el8.service.urls.get('smokingStatus'),
                success: function(data) {
                    if (data) {
                        el8.ptdata.currSmokingStatus = el8.ptdata.smokingStatuses.create(data);
                    }
                }
            });
            $.when( historyRequest, smokingRequest ).done(
                function() {
                    reportOnFirstLoad();
                    $(containerSelector).removeClass('el8Loading');
                    if (callbackFn) { callbackFn(); }
                }
            );
        },
        initFn: function() {

            var container = $(containerSelector);
            el8.uiwidget.collapsible({
                container: $('#patient-info-summary'),
                triggerElt : $('#patient-info-summary-header'),
                statusElt : $('#patient-info-summary-status')
            });
            that.addContainer($('#patient-info-summary'));

            el8.uiwidget.collapsible({
                container: $('#pfsh-summary'),
                triggerElt: $('#pfsh-summary-header'),
                statusElt: $('#pfsh-summary-status')
            });
            that.addContainer($('#pfsh-summary'));

            _HISTORY_ITEM_TYPES.map(function(type) {
                listeditors[type] = new el8.uiwidget.listeditor({
                    list: $('#'+type+'-history-list', container),
                    noRemove: true,
                    infoText: getInfoText(type),
                    idPrefix: idPrefix,
                    dropdownFn: (function(_type) {
                        if (el8Globals.TEASE) {
                            return null;
                        } else {
                            return function($target, id) {
                                var historyItem = el8.ptdata.historyItems[_type].getById(id);
                                el8.appchart.refpanel.actionsMenu.display(
                                    $target, historyItem, {top: 14, left: 20}, el8.appshared.feedItemActions(historyItem)
                                );
                                return false;
                            };
                        }
                    })(type),
                    onEditStart: function($entry) {
                        var itemId = $entry.attr('_id');
                        // Only set to inline if edit source for this ID doesn't
                        // exist. If it already exists, that means it was set by
                        // editItem below (triggered when selecting Edit from
                        // the action menu).
                        if (!editSourceForId[itemId]) {
                          editSourceForId[itemId] = 'inline';
                        }
                    },
                    saveFn: (function(_type) {
                        return function(id, text, index, opts) {
                            if (id) {
                                var historyItem = el8.ptdata.historyItems[_type].getById(id);
                                if (historyItem.getText() !== text) {
                                    el8.util.amplitude.logEvent('edit clinical profile history', {
                                      section: _type,
                                      source: editSourceForId[id]
                                    });
                                    editSourceForId[id] = null;

                                    historyItem.setText(text);
                                    return el8.ptdata.historyItems[_type].saveItem(id, true, opts);
                                } else {
                                    if (opts && opts.successCb) {
                                        opts.successCb(historyItem);
                                    }
                                    return historyItem;
                                }
                            } else {
                                el8.util.amplitude.logEvent('document clinical profile history', {
                                  section: _type
                                });
                                return el8.ptdata.historyItems[_type].saveNew({
                                    id: null,
                                    text: text
                                }, true, opts);
                            }
                        };
                    })(type),
                    removeFn: (function(_type) {
                        return function(id) {
                            el8.ptdata.historyItems[_type].deleteItem(id);
                        };
                    })(type),
                    // Make only the main history item sections sortable
                    sortable: (type !== 'legal' && type !== 'consultation' && type !=='immunization' && type !== 'maintenance'),
                    sortSaveFn: function(idArray) {
                        $.el8_ajax({
                            type: 'POST',
                            url: el8.service.urls.get('sortHistoryItems'),
                            data: JSON.stringify({rank: idArray}),
                            success: function(data) {
                                // update all the cached ranks
                                if (data && data.length) {
                                    data.forEach(function(historyItemJson) {
                                        el8.ptdata.historyItems[historyItemJson.type.toLowerCase()].create(historyItemJson);
                                    });
                                }
                            }
                        });
                    },
                    getItemTextFn: function(item) { return item.getText(); },
                    getItemIdFn: function(item) { return item.getId(); }
                }).init();
                listeditors[type].hideLe(); // otherwise the history section looks really ugly during page load
            });

            $('#pfsh-snapshot-trigger').click(function(event) {
                event.preventDefault();
                el8.util.amplitude.logEvent('export clinical profile history to note', {
                  section: 'All'
                });
                el8.appchart.mgr.notes.addHistorySnapshot();
            });

            $('#pfsh-summary').on('click', '.smoking-status-trigger',  function() {
                el8.util.amplitude.logEvent('add structured field to clinical profile history', {
                  section: 'habits',
                  name: 'smoking'
                });
                el8.appchart.dialog.smokingStatus.show();
                return false;
            });

            container.on('click', '.smoking-status-actions-trigger',  function(e) {
                var menu = [
                    {
                        actionText: 'Edit',
                        actionFn: function() {
                            el8.appchart.dialog.smokingStatus.show();
                        }
                    },
                    {
                        actionText: 'Export to Note',
                        actionFn: function() {
                            el8.appchart.mgr.notes.addReference({item: el8.ptdata.currSmokingStatus});
                        }
                    }
                ];
                el8.appchart.refpanel.actionsMenu.display(
                    $(this), null, {top: 17, left: 13}, menu
                );
                return false;
            });

            /** Add in the "+ Add Vaccination" / "View Schedule" buttons **/
            $('#immunization-history-list').closest('.immunization-section').append(
                el8.template.appchart.refpanel.immunizations.triggers()
            );

            /**
             * Add "Check Registry" button if the practice has Immunization Registries
             * with one of the appropriate history integration types
             */
            if (el8.practicedata.immunizationRegistries.canCheckRegistryHistoryForecast()) {
                 $('#immunization-buttons').append(
                    el8.template.appchart.refpanel.immunizations.checkHistoryTrigger()
                );
            }

        },

        dataRenderers: (function() {
            var renderers = [];
            _HISTORY_ITEM_TYPES.map(function(type) {
                renderers.push({
                    entitySet: el8.ptdata.historyItems[type],
                    listenFn: (function(_type) {
                        return function() {
                            var allItems = el8.ptdata.historyItems[_type].sorted();
                            listeditors[_type].addEntries(allItems);
                        };
                    })(type)
                });
            });
            renderers.push({
                entitySet: el8.ptdata.smokingStatuses,
                listenFn: function() {
                    if (el8.ptdata.currSmokingStatus &&
                            el8.ptdata.currSmokingStatus.getSmokingStatus()) {
                        $('#add-smoking-trigger', $('#pfsh-summary')).empty();
                        $('#habits-history-smoking', $('#pfsh-summary')).html(
                            el8.template.appchart.refpanel.history.smokingStatus(
                                el8.ptdata.currSmokingStatus.asSoyMap())
                        );
                    } else {
                        $('#habits-history-smoking', $('#pfsh-summary')).empty();
                        $('#add-smoking-trigger', $('#pfsh-summary')).html(
                            el8.template.appchart.refpanel.history.smokingStatusButton()
                        );
                    }
                }
            });
            return renderers;
        })()

    });

    that.editItem = function(id, type) {
        if (!id) { return null; }

        editSourceForId[id] = 'actions menu';

        var $entry = $('#'+idPrefix+'_'+id, $(containerSelector));
        listeditors[type.toLowerCase()].editEntry($entry);
    };

    that.removeItem = function(id, type) {
        if (!id) { return null; }
        var $entry = $('#'+idPrefix+'_'+id, $(containerSelector));
        listeditors[type.toLowerCase()].removeEntry($entry, true);
    };

    that.resizeAdjust = function() {
        for (var l in listeditors) {
            if (listeditors.hasOwnProperty(l)) {
                listeditors[l].resizeAdjust();
            }
        }
    };

    $(document).on('el8_refBoardChange', function() {
        that.resizeAdjust();
    });

    function getInfoText(historyType) {
        switch (historyType) {
            case 'maintenance':
                return 'add health maintenance note';
            case 'cognitive':
            case 'functional':
            case 'psychological':
                return 'add ' + historyType + ' status';

            default:
                return 'add ' + historyType + ' history item';
        }
    }

    return that;

})();
